// //Contentful
// const spaceId = "s6vxh8aesskl"
// const environmentId = "master"
// const accessToken = "aR0gRGjVQ7RnZAO9Ezy4RJVZnPla62rGO9HialCrU8w"
// const url = `https://cdn.contentful.com/spaces/${spaceId}/environments/${environmentId}/entries?access_token=${accessToken}`

// //
// async function getData () {
//   try {
//     const response = await fetch(url)
//     const data = await response.json()
//     console.log(data)

//   }
//   catch (error) {
//     alert(error)
//   } 
// }

import * as contentful from 'contentful'

export const client = contentful.createClient ({
  space: 's6vxh8aesskl',
  accessToken: 'aR0gRGjVQ7RnZAO9Ezy4RJVZnPla62rGO9HialCrU8w'
})

